import createItemFetcher from "../helpers/item";
import { createUseFetch, createUseItem } from "../helpers/fetchHooks";
import { createActionDuck } from "../helpers/action";
import { createNotificationOnCreateEpic, createNotificationOnCreateErrorEpic, } from "./updateNotification";
import { Observable } from "rxjs/Observable";
import { combineDucks } from "../helpers/combineDucks";
function updateArchiveOnUpdate(ActionKeys) {
    return (actions$) => actions$
        .ofType(ActionKeys.FINISH)
        .mergeMap((action) => Observable.of(archiveStringMMI.actions.fetchItem(action.config)));
}
export const computeArchiveStringMMIUrl = (config) => {
    const { scenario, workspace } = config;
    return `/api/v1/archive/${scenario}/${workspace}/archiveid`;
};
const computeItemId = (config) => {
    const { scenario, workspace } = config;
    return `${scenario}_${workspace}_archive`;
};
export const archiveStringMMI = createItemFetcher(computeArchiveStringMMIUrl, "ARCHIVE_GET", computeItemId);
export const createArchiveStringMMI = () => archiveStringMMI;
export const useArchiveStringMMI = createUseFetch(archiveStringMMI, (state) => state.archiveMMI.archiveStringMMI);
export const getArchiveStringMMI = createUseItem(archiveStringMMI, (state) => state.archiveMMI.archiveStringMMI);
const computeAfArchiveIdUrl = (config) => {
    const { scenario, workspace } = config;
    return `/api/v1/afarchive/${scenario}/${workspace}/archiveid`;
};
const computeAfArchiveId = (config) => {
    const { scenario, workspace } = config;
    return `${scenario}_${workspace}_afarchive`;
};
export const afArchiveId = createItemFetcher(computeAfArchiveIdUrl, "AFARCHIVE_GET", computeAfArchiveId);
export const createAfArchiveId = () => afArchiveId;
export const useAfArchiveId = createUseFetch(afArchiveId, (state) => state.afArchiveId);
export const computeArchiveStringPost = (config) => {
    const { scenario, workspace, value } = config;
    const url = `/api/v1/archive/${scenario}/${workspace}/archiveid/${value}`;
    return {
        method: "POST",
        url,
    };
};
export const archiveStringPost = createActionDuck("ARCHIVE_POST", computeArchiveStringPost, computeItemId);
archiveStringPost.middleware.push(createNotificationOnCreateEpic(archiveStringPost.ActionKeys), createNotificationOnCreateErrorEpic(archiveStringPost.ActionKeys), updateArchiveOnUpdate(archiveStringPost.ActionKeys));
export const archiveMMI = combineDucks({
    archiveStringMMI,
    archiveStringPost,
});
//# sourceMappingURL=index.js.map